module.exports = __webpack_public_path__ + "img/banner3.3fe9e9ed.png";